import React from 'react';
import { Router, BrowserRouter } from 'react-router-dom';
import RouterHistory, { initialiseHistory } from './RouterHistory';
import { CompatRouter } from "react-router-dom-v5-compat";

//imports for pages that can be routed to
//this module is distinct from RouterInstance to break circular dependencies
import MasterPageView from '../MasterPageView.jsx';
import AuthsMasterPageView from '../../../Auths/Common/Components/AuthsMasterPageView.jsx';

import { Provider } from 'react-redux';

import type { Store } from '@reduxjs/toolkit';

const getAppRouter = (basename: string, routes: JSX.Element, reduxStore: Store) => {
    initialiseHistory(basename);
    return (
        <Router history={RouterHistory.getHistory()}>
            <CompatRouter>
                {
                    reduxStore
                        ?
                        <Provider store={reduxStore}>
                            <MasterPageView>{routes}</MasterPageView>
                        </Provider>
                        :
                        <MasterPageView>{routes}</MasterPageView>
                }
            </CompatRouter>
        </Router>
    );
};

const getAuthsAppRouter = (routes: JSX.Element, authsStore: Store) => {
    return (
        <BrowserRouter basename="/">
            <CompatRouter>
                <Provider store={authsStore}>
                    <AuthsMasterPageView>{routes}</AuthsMasterPageView>
                </Provider>
            </CompatRouter>
        </BrowserRouter>
    );
};

export { getAppRouter, getAuthsAppRouter };
